/**
 * Arabic for passenger flow. Proposed; pending native aviation review.
 * Checkpoint codes and flight designators are kept as written.
 */
const ar: Record<string, string> = {
  "Passenger flow": "تدفق المسافرين",
  "Every queue forecast before it forms: show-up from each departure's schedule and profile (a pilgrim group comes hours early), check-in at the desks the allocation gave the flight, then security and passport control in turn, and the arrivals' wave at passport control shaped by bridge or bus; the fewest lanes and booths that hold each target, with the time to call the staff and the officer-hours; the people predicted to miss the gate, flight by flight, and how many the recommended lanes save; reset by what a sensor or a supervisor counts.":
    "توقّع كل طابور قبل أن يتشكّل: وصول المسافرين من جدول كل رحلة مغادرة ونوعها (مجموعات الحجاج تصل قبل ساعات)، ثم إنهاء الإجراءات على الكاونترات التي خصّصها المحرك للرحلة، ثم التفتيش الأمني والجوازات بالترتيب، وموجة القادمين إلى الجوازات بحسب الجسر أو الحافلة؛ وأقل عدد من المسارات والكبائن يحقق كل هدف، مع وقت استدعاء الموظفين وساعات العمل؛ والمسافرون المتوقع أن يفوتهم إغلاق البوابة، رحلةً رحلة، وكم ينقذ منهم الاقتراح؛ ويُصحَّح بما يعدّه حسّاس أو مشرف.",
  "Every queue forecast before it forms — from each flight's predicted time and profile, the desks and stands the allocation gave it — the lanes and booths that keep it under target, called in time, and the people who will miss their flight if nothing changes.":
    "توقّع كل طابور قبل أن يتشكّل — من الوقت المتوقع لكل رحلة ونوعها، والكاونترات والمواقف المخصّصة لها — والمسارات والكبائن التي تُبقيه دون الهدف، مع استدعاء الموظفين في وقته، والمسافرون الذين ستفوتهم رحلاتهم إن لم يتغير شيء.",

  "No flights on the record in the next hours, so no queue to forecast. The flight record fills from the airlines' seasonal schedule (SSIM) and their movement messages — load the schedule on Flight record.":
    "لا رحلات في السجل خلال الساعات القادمة، فلا طابور لتوقعه. يمتلئ سجل الرحلات من الجدول الموسمي لشركات الطيران (SSIM) ورسائل الحركة — حمّل الجدول من صفحة سجل الرحلات.",
  "No checkpoints are set up for this site yet.": "لم تُعدّ نقاط تفتيش لهذا الموقع بعد.",

  /* the sample checkpoints' names */
  "Domestic security": "التفتيش الأمني الداخلي",
  "International security": "التفتيش الأمني الدولي",
  "Passport control, departures": "جوازات المغادرة",
  "Passport control, arrivals": "جوازات القدوم",

  /* stages and profiles */
  "Check-in": "إنهاء الإجراءات",
  "Passport control out": "جوازات المغادرة",
  "Passport control in": "جوازات القدوم",
  domestic: "داخلي",
  international: "دولي",
  "pilgrim group": "مجموعة حجاج",

  /* summary and tiles */
  "Longest predicted wait {w} min at {code}; {r} min with the recommended lanes.":
    "أطول انتظار متوقع {w} دقيقة في {code}؛ و{r} دقيقة بالمسارات المقترحة.",
  "{n} people predicted to miss the gate; {r} with the recommended lanes.":
    "{n} مسافراً متوقع أن يفوتهم إغلاق البوابة؛ و{r} بالمسارات المقترحة.",
  "Who will miss their flight?": "من ستفوته رحلته؟",
  "longest wait ahead": "أطول انتظار قادم",
  "at {code}; {r} min with the recommended lanes": "في {code}؛ و{r} دقيقة بالمسارات المقترحة",
  "may miss the gate": "قد يفوتهم إغلاق البوابة",
  "{r} with the recommended lanes": "{r} بالمسارات المقترحة",
  "flights short of desks": "رحلات تنقصها كاونترات",
  "check-in wait over {n} min": "انتظار إنهاء الإجراءات أكثر من {n} دقيقة",
  "officer-hours ahead": "ساعات عمل الموظفين القادمة",

  /* checkpoints */
  Checkpoints: "نقاط التفتيش",
  Flights: "الرحلات",
  "Counts and settings": "العدّ والإعدادات",
  "Rostered lanes": "المسارات المجدولة",
  Recommended: "المقترح",
  "{stage} · target {t} min · {n} people ahead": "{stage} · الهدف {t} دقيقة · {n} مسافراً قادماً",
  "rostered: longest wait {w} min at {at}, {o} min over target": "المجدول: أطول انتظار {w} دقيقة في {at}، و{o} دقيقة فوق الهدف",
  "recommended: longest wait {w} min, {o} min over target": "المقترح: أطول انتظار {w} دقيقة، و{o} دقيقة فوق الهدف",
  "officer-hours {a} → {b}": "ساعات الموظفين {a} ← {b}",
  "{src} counted {o} in the queue at {at}; the model had {p}. The forecast starts from the count.":
    "عدّ {src} {o} في الطابور عند {at}؛ وكان النموذج يتوقع {p}. التوقع يبدأ من العدّ.",
  "The sensor": "الحسّاس",
  "A supervisor": "مشرف",
  "target {t} min": "الهدف {t} دقيقة",
  "wait {w} min": "انتظار {w} دقيقة",
  "{n} arriving": "{n} قادماً",
  "{n} lane|{n} lanes": "لا مسارات|مسار واحد|مساران|{n} مسارات|{n} مساراً|{n} مسار",
  "Bars: the wait for somebody arriving then. Line: lanes open, of {n}.": "الأعمدة: انتظار من يصل حينها. الخط: المسارات المفتوحة من {n}.",
  "What to change, and when to call the staff": "ما يجب تغييره، ومتى يُستدعى الموظفون",
  "call by {t}": "الاستدعاء قبل {t}",
  "Adopt the recommended plan": "اعتمد الخطة المقترحة",
  "Adopted. The forecast now runs on it.": "اعتُمدت. التوقع يعمل عليها الآن.",
  "The rostered plan already holds the target.": "الخطة المجدولة تحقق الهدف أصلاً.",

  /* the engine's reasons */
  "{n} predicted to reach the gate after it closes at {close}; the longest wait on their way is {wait} min at {where}.":
    "{n} متوقع وصولهم إلى البوابة بعد إغلاقها في {close}؛ وأطول انتظار في طريقهم {wait} دقيقة في {where}.",
  "the current plan lets the wait reach {w} min at {at} (target {target}){names}":
    "الخطة الحالية تترك الانتظار يبلغ {w} دقيقة في {at} (الهدف {target}){names}",
  "; busiest: {names}": "؛ الأكثر ازدحاماً: {names}",
  "demand falls; {n} officer freed|demand falls; {n} officers freed":
    "ينخفض الطلب|ينخفض الطلب؛ يُفرَّغ موظف واحد|ينخفض الطلب؛ يُفرَّغ موظفان|ينخفض الطلب؛ يُفرَّغ {n} موظفين|ينخفض الطلب؛ يُفرَّغ {n} موظفاً|ينخفض الطلب؛ يُفرَّغ {n} موظف",

  /* flights */
  "Who may miss the gate": "من قد يفوتهم إغلاق البوابة",
  "people predicted to reach the gate after it closes, and where they are held up": "المسافرون المتوقع وصولهم إلى البوابة بعد إغلاقها، وأين يتأخرون",
  Departs: "المغادرة",
  "With the recommended lanes": "بالمسارات المقترحة",
  "Nobody is predicted to miss a gate.": "لا يُتوقع أن يفوت أحداً إغلاق البوابة.",
  "Check-in, flight by flight": "إنهاء الإجراءات، رحلةً رحلة",
  "each flight's own queue at the desks the allocation gave it": "طابور كل رحلة على الكاونترات المخصّصة لها",
  Profile: "النوع",
  Desks: "الكاونترات",
  "At the desks": "عند الكاونترات",
  "Longest wait": "أطول انتظار",
  "(not allocated)": "(غير مخصّصة)",
  "Give it {n} desks": "خصّص لها {n} كاونترات",
  "sized from the passenger-flow forecast": "حُدِّد العدد من توقع تدفق المسافرين",
  "Refused: {why}": "مرفوض: {why}",
  "Given {n} desks ({c}).": "خُصّص {n} كاونترات ({c}).",
  "Given {n} desks ({c}) — the most free side by side; it needed {need}.": "خُصّص {n} كاونترات ({c}) — أكثر ما يتوفر متجاوراً؛ وكانت تحتاج {need}.",
  "No run of more desks is free while it is open.": "لا توجد كاونترات إضافية متجاورة شاغرة طوال فترة فتحها.",
  "No check-in queue ahead.": "لا طابور إنهاء إجراءات قادم.",
  "Arrivals at passport control": "القادمون عند الجوازات",
  "a bridge sends a stream; a remote stand sends busloads": "الجسر يرسل تدفقاً متصلاً؛ والموقف البعيد يرسل حافلات",
  "On block": "على الموقف",
  "Wait at passport control": "الانتظار عند الجوازات",
  bus: "حافلة",
  bridge: "جسر",
  "no stand yet": "بلا موقف بعد",
  "No arrivals in the next hours.": "لا رحلات قادمة في الساعات القادمة.",

  /* counts and settings */
  "Count a queue": "عدّ طابور",
  "a count resets the forecast at that moment; the gap to the model is shown on the checkpoint":
    "العدّ يعيد ضبط التوقع عند تلك اللحظة؛ ويُعرض الفرق عن النموذج على نقطة التفتيش",
  Checkpoint: "نقطة التفتيش",
  "What was counted": "ما الذي عُدّ",
  "people in the queue": "أشخاص في الطابور",
  "minutes of wait": "دقائق انتظار",
  "{n} in the queue": "{n} في الطابور",
  "{n} min wait": "انتظار {n} دقيقة",
  sensor: "حسّاس",
  "a person": "شخص",
  "lanes, pace, target and the walk to the gates — the figures the forecast runs on":
    "المسارات والوتيرة والهدف والمشي إلى البوابات — الأرقام التي يعمل عليها التوقع",
  "Lanes at most": "أقصى عدد مسارات",
  "People per lane an hour": "مسافرون لكل مسار في الساعة",
  "Target wait (min)": "الانتظار المستهدف (دقيقة)",
  "Staff per lane": "موظفون لكل مسار",
  "Domestic is decided by the other airport: {list}": "الداخلي يُحدَّد بالمطار الآخر: {list}",
  "counts, plans adopted and settings, with who": "العدّ والخطط المعتمدة والإعدادات، ومن قام بها",
};
export default ar;
